import { render, staticRenderFns } from "./page-footer.vue?vue&type=template&id=7da2f443&scoped=true&"
import script from "./page-footer.vue?vue&type=script&lang=ts&"
export * from "./page-footer.vue?vue&type=script&lang=ts&"
import style0 from "./page-footer.vue?vue&type=style&index=0&id=7da2f443&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da2f443",
  null
  
)

export default component.exports